import { apiClient } from './apiClient';

const getOrders = async (data) => {
  return await apiClient.get('/orders', data);
};

const createOrder = async (data) => {
  return await apiClient.post_form('/orders', data);
};

const validateOrder = async (data) => {
  return await apiClient.post_form('/orders/create', data);
};

const getEditOrder = async (id, data) => {
  return await apiClient.get(`/orders/edit/${id}`, data);
};

const getOrderConfirm = async (id, data) => {
  return await apiClient.get(`/orders/confirm/${id}`, data);
};

const calculateOrderExchange = async (id, data) => {
  return await apiClient.get(`/api/calculate/${id}`, data);
};

export const ordersApi = {
  getOrders,
  createOrder,
  validateOrder,
  getEditOrder,
  getOrderConfirm,
  calculateOrderExchange,
};
